import styled, { css } from 'styled-components'

import { type IStatusCardLegacyContentTableProps } from '../StatusCardLegacyContentTable'

const buildHeaderTemplate = ({
  headerLeft,
  headerRight,
}: IStatusCardLegacyContentTableProps) => {
  const headerGrid = []

  if (!headerLeft?.label) {
    headerGrid.push('leftHeaderValue leftHeaderValue leftHeaderValue')
  } else {
    headerGrid.push('leftHeaderLabel leftHeaderValue leftHeaderValue')
  }

  if (!headerRight?.label) {
    headerGrid.push('rightHeaderValue rightHeaderValue')
  } else {
    headerGrid.push('rightHeaderLabel rightHeaderValue')
  }

  return headerGrid
}

const buildDataTemplate = ({
  dataLeft = [],
  dataRight = [],
}: IStatusCardLegacyContentTableProps) => {
  const dataGrids: string[][] = []

  dataLeft.forEach((_, index) => {
    dataGrids[index] = dataGrids[index] || []

    dataGrids[index].push(`leftLabel${index} leftValue${index} spacer`)

    if (!dataRight?.[index]) dataGrids[index].push('. .')
  })

  dataRight.forEach((_, index) => {
    dataGrids[index] = dataGrids[index] || ['. . spacer']

    dataGrids[index].push(`rightLabel${index} rightValue${index}`)
  })

  return dataGrids
}

const buildGridTemplate = (props: IStatusCardLegacyContentTableProps) => {
  const grids = [buildHeaderTemplate(props), ...buildDataTemplate(props)]

  const gridTemplateAreas = grids.map((grid) => `"${grid.join(' ')}"`).join(' ')

  return css`
    grid-template-areas: ${gridTemplateAreas};
  `
}

export const StatusCardLegacyContentTableStyled = styled.div<IStatusCardLegacyContentTableProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  display: grid;

  ${(props) =>
    buildGridTemplate({
      headerLeft: props.headerLeft,
      headerRight: props.headerRight,
      dataLeft: props.dataLeft,
      dataRight: props.dataRight,
    })}

  row-gap: 0.75em;
  grid-template-columns:
    minmax(6em, max-content) minmax(6em, max-content) minmax(1em, auto)
    minmax(1em, max-content)
    minmax(6em, max-content);
`
